import React from 'react';
import styles from 'routes/vendorRe/pages/VendorApp.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import mainLogo from 'routes/vendorRe/images/main_logo.png';
import useCustomMove from 'routes/vendorRe/hooks/useCustomMove';

const VenderApp = () => {
    const {moveToHome} = useCustomMove();

    return (
        <Container display="flex" height="100vh" backgroundColor={"#FE531F"}>
            <VerticalFlex>
                <FlexChild justifyContent="center" alignItems="center">
                    <img className={styles.logoImg} src={mainLogo} alt='PUFFU 로고' onClick={() => moveToHome()} />
                    <span className={styles.logoTxt}>판매자 전용</span>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VenderApp;